import { useEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'

const Portal = ({ children }) => {
  let portalRef = useRef()
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    portalRef.current = document.querySelector('#cgc-portal')
    if (portalRef.current) {
      setMounted(true)
    }
  }, [])

  return mounted ? createPortal(children, portalRef.current) : null
}

export default Portal
